




























































import { Component, Vue } from "vue-property-decorator";

@Component({
      name      : "Home",
      components: {}
  })
  export default class Home
      extends Vue {
  }
